

import {Injectable} from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {AuthService} from 'ng2-ui-auth';
// import {ShareUserDataService} from '../user-data';
import { HandleRequest } from '../handleRequest';
import { catchError, map } from 'rxjs/operators';
import { Events } from '../events';
// import { HttpClient } from '@angular/common/http';
declare var CONFIG:any;
@Injectable()
export class AuthenticationService {
  constructor(private auth: AuthService, private handleRequest:HandleRequest,private events: Events) {
  }

  login(credentials): Observable<any> {
    console.log("credentials:" , credentials);

    return this.auth.login(credentials,CONFIG.API_ENDPOINT+"/api/login?username="+credentials.username+"&password="+credentials.password)
          .pipe(
            map(res=>{
              console.log(res);
              this.auth.setToken(res.token.access)
              return res;
            }),
            catchError((error) => {
              this.handleRequest.handleErrors(error._body, error.status);
              return throwError(error.message || 'server Error');
            }))
      // .toPromise().then(res => {
      //   console.warn("login response",res.json());
      //   let data = res.json()
      //   // this.sharedData.setUserData(data.user)
      //   // this.events.publish('user:reload', data.user);
      //   return data
      // })
      // .catch(err=>{
      //   this.handleRequest.handleErrors(err._body,err.status)
      //   throw new Error(err);
      // });
  }
  // loginWithToken(token:string): Observable<any> {
    // console.log("token:" , token);
    // return this.handleRequest.loginWithToken("/auth/user_login_token",token)
    //   .map(res => {
    //     console.warn("login response",res.json());
    //     let data = res.json()
    //     this.sharedData.setUserData(data.user)
    //     // this.events.publish('user:reload', data.user);
    //     return data
    //   })
    //   .pipe(catchError(err=>{
    //     this.handleRequest.handleErrors(err._body,err.status)
    //     throw new Error(err);
    //   }));
  // }
  // resetPassword(body): Observable<any> {
    // return this.handleRequest.resetPassword("/auth/forget_password_user", body)
    // .map(res => res.json())
    // .toPromise();
    // .pipe(catchError(err=>{
    //   this.handleRequest.handleErrors(err._body,err.status)
    //   throw new Error(err);
    // }));
  // }
  // DEPRECATED
/*   signup(params) {
    return Observable.create(observable => {
      this._signup(params).subscribe(user => {
        this.auth.setToken(user.access_token);
        this.onLoginSuccess(user);
        observable.next(user);
        observable.complete();
      });
    });
  }
  private onLoginSuccess(user) {
    // Do What ever you like with the user object
    this.sharedData.setUserData(user)
    return user;
  }

  authenticate(provider: string): Observable<any> {
    return Observable.create(observable => {
      return this._authenticate(provider).subscribe(user => {
        this.onLoginSuccess(user);
        observable.next(user);
        observable.complete();
      });
    });
  }
  _signup(user): Observable<any> {
    return this.auth.signup(user).map(res => res.json());
  }

  _authenticate(provider): Observable<Response> {
    return this.auth.authenticate(provider).map(res => res.json());
  } */
}
